<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">{{ tituloModal }}</h2>
    @if (identificacao) {
      <span class="modal-subtitle">{{ identificacao }}</span>
    }
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn icon-mat-symbols-btn" aria-label="Fechar" (click)="fechar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content item-dialog-content">
  @if (isLoading || isCarregandoRegime) {
    <div class="d-flex flex-column gap-3 py-2">
      <app-loading-box height="28" width="280"></app-loading-box>
      <div class="row g-3">
        <div class="col-12 col-md-3"><app-loading-box height="56"></app-loading-box></div>
        <div class="col-12 col-md-3"><app-loading-box height="56"></app-loading-box></div>
        <div class="col-12 col-md-3"><app-loading-box height="56"></app-loading-box></div>
        <div class="col-12 col-md-3"><app-loading-box height="56"></app-loading-box></div>
      </div>
    </div>
  } @else {
    @if (isListasIndisponiveis) {
      <app-alert-card type="error" title="Listas de tributos indisponíveis">
        Não foi possível carregar as listas de tributos do Motor Fiscal. Os dados do item foram mantidos, mas CST, CSOSN e
        cClassTrib só podem ser alterados depois que as listas carregarem.
        <div alertActions>
          <button mat-stroked-button type="button" class="btn-secondary btn-spinner" [class.btn-loading]="isCarregandoListas"
            [disabled]="isCarregandoListas" aria-label="Tentar novamente" (click)="carregarLookups()">
            <mat-icon class="material-symbols-outlined">refresh</mat-icon>
            Tentar novamente
            @if (isCarregandoListas) { <mat-spinner diameter="20"></mat-spinner> }
          </button>
        </div>
      </app-alert-card>
    }

    @if (isItemNovo) {
      <app-alert-card type="info" title="Novo item" icon="edit_note">
        Este item ainda não foi gravado. Ele é salvo junto com o documento.
      </app-alert-card>
    }

    @if (isRecalculoPendente && mostraAbasFiscais) {
      <app-alert-card type="warning" title="Recálculo pendente" icon="calculate">
        Os tributos deste item ainda não foram calculados pelo motor fiscal.
      </app-alert-card>
    }

    <mat-tab-group class="item-tabs" appTabsScroll [mat-stretch-tabs]="false" [disablePagination]="true"
      [(selectedIndex)]="abaSelecionada">
      <mat-tab label="Dados do item">
        <div class="aba-conteudo">
          <app-vd-item-aba-dados
            [item]="item"
            [naturezas]="lookups.naturezas"
            [origensMercadoria]="lookups.origensMercadoria"
            [isSomenteLeitura]="data.isSomenteLeitura"
            [exibeDescontoPorItem]="data.exibeDescontoPorItem"
            [tetoDesconto]="data.tetoDesconto"
            [localizacoesEstoque]="data.localizacoesEstoque"
            [mascaraPreco]="data.mascaraPreco"
            [mascaraQuantidade]="data.mascaraQuantidade"
            [mascaraInteira]="data.mascaraInteira"
            [mascaraPercentual]="data.mascaraPercentual">
          </app-vd-item-aba-dados>
        </div>
      </mat-tab>

      <!-- Abas de tributo: só existem com o cálculo de impostos ligado no processo (§6.1). -->
      @if (mostraAbasFiscais) {
        @if (isSimplesNacional) {
          <mat-tab>
            <ng-template mat-tab-label>
              Simples
              @if (isAbaInvalida('icms')) {
                <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
              }
            </ng-template>
            <div class="aba-conteudo">
              <app-vd-item-aba-simples [form]="grupo('icms')" [isRecalculoPendente]="isRecalculoPendente"
                [listaCsosn]="lookups.csosns" [listaModalidadeBcSt]="lookups.modalidadesBcSt">
              </app-vd-item-aba-simples>
            </div>
          </mat-tab>
        } @else {
          <mat-tab>
            <ng-template mat-tab-label>
              ICMS
              @if (isAbaInvalida('icms')) {
                <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
              }
            </ng-template>
            <div class="aba-conteudo">
              <app-vd-item-aba-icms [form]="grupo('icms')" [isRecalculoPendente]="isRecalculoPendente"
                [listaCstIcms]="lookups.cstsIcms" [listaModalidadeBc]="lookups.modalidadesBc"
                [listaModalidadeBcSt]="lookups.modalidadesBcSt" [listaMotivoDesoneracao]="lookups.motivosDesoneracao">
              </app-vd-item-aba-icms>
            </div>
          </mat-tab>
        }

        <mat-tab>
          <ng-template mat-tab-label>
            IPI
            @if (isAbaInvalida('ipi')) {
              <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
            }
          </ng-template>
          <div class="aba-conteudo">
            <app-vd-item-aba-ipi [form]="grupo('ipi')" [listaCstIpi]="lookups.cstsIpi" [isRecalculoPendente]="isRecalculoPendente">
            </app-vd-item-aba-ipi>
          </div>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            PIS
            @if (isAbaInvalida('pis')) {
              <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
            }
          </ng-template>
          <div class="aba-conteudo">
            <app-vd-item-aba-pis [form]="grupo('pis')" [listaCstPis]="lookups.cstsPis" [isRecalculoPendente]="isRecalculoPendente">
            </app-vd-item-aba-pis>
          </div>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            COFINS
            @if (isAbaInvalida('cofins')) {
              <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
            }
          </ng-template>
          <div class="aba-conteudo">
            <app-vd-item-aba-cofins [form]="grupo('cofins')" [listaCstCofins]="lookups.cstsCofins" [isRecalculoPendente]="isRecalculoPendente">
            </app-vd-item-aba-cofins>
          </div>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            IBS/CBS
            @if (isAbaInvalida('ibsCbs')) {
              <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
            }
          </ng-template>
          <div class="aba-conteudo">
            <app-vd-item-aba-ibs-cbs [form]="grupo('ibsCbs')" [listaCstIbsCbs]="lookups.cstsIbsCbs"
              [listaCclasstribIbsCbs]="lookups.classificacoesIbsCbs" [relacoesCstCclasstrib]="lookups.relacoesIbsCbs"
              [isRecalculoPendente]="isRecalculoPendente">
            </app-vd-item-aba-ibs-cbs>
          </div>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            ICMS DIFAL
            @if (isAbaInvalida('difal')) {
              <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
            }
          </ng-template>
          <div class="aba-conteudo">
            <app-vd-item-aba-difal [form]="grupo('difal')" [isRecalculoPendente]="isRecalculoPendente">
            </app-vd-item-aba-difal>
          </div>
        </mat-tab>
      }

      <!-- Lote/série: só para produto que controla lote ou série; o ícone de erro fica até a seleção fechar a quantidade. -->
      @if (mostraAbaLoteSerie) {
        <mat-tab>
          <ng-template mat-tab-label>
            Lote/série
            @if (motivoLoteSerie) {
              <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
            }
          </ng-template>
          <div class="aba-conteudo">
            <app-vd-item-aba-lote-serie
              [idProduto]="item.get('dados.idProduto')?.value"
              [idLocalizacaoEstoque]="item.get('dados.idLocalizacaoEstoque')?.value"
              [idVenda]="data.idVenda"
              [nomeLocalizacaoEstoque]="nomeLocalizacaoEstoque"
              [quantidadeAlvo]="item.get('dados.quantidade')?.value ?? 0"
              [isControlaSeries]="isControlaSeries"
              [isUnidadeMedidaFracionada]="item.get('dados.isUnidadeMedidaFracionada')?.value !== false"
              [isSomenteLeitura]="data.isSomenteLeitura"
              [lotes]="item.get('lotes')?.value ?? []"
              [series]="item.get('series')?.value ?? []"
              (lotesChange)="aoAlterarLotes($event)"
              (seriesChange)="aoAlterarSeries($event)">
            </app-vd-item-aba-lote-serie>
          </div>
        </mat-tab>
      }

      <!-- "Outros" e comissão são do PEDIDO: o orçamento não gera nota nem paga comissão. -->
      @if (mostraAbasDePedido) {
        <mat-tab label="Outros">
          <div class="aba-conteudo">
            <app-vd-item-aba-outros [item]="item" [lookups]="lookups"
              [isSomenteLeitura]="data.isSomenteLeitura"
              [mascaraQuantidade]="data.mascaraQuantidade"
              [mascaraInteira]="data.mascaraInteira">
            </app-vd-item-aba-outros>
          </div>
        </mat-tab>

        <mat-tab label="Comissão">
          <div class="aba-conteudo">
            <app-vd-item-aba-comissao [item]="item" [mascaraPercentual]="data.mascaraPercentual">
            </app-vd-item-aba-comissao>
          </div>
        </mat-tab>
      }
    </mat-tab-group>
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer item-dialog-footer">
  <!-- Origem dos valores e recálculo só existem com o cálculo de impostos ligado no processo. -->
  <div class="item-dialog-aviso">
    @if (mostraAbasFiscais) {
      <span class="origem-valores-chip">{{ origemValoresApurados }}</span>
      <span>{{ textoRodape }}</span>
    }
  </div>
  <div class="item-dialog-botoes">
    <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()">Cancelar</button>
    @if (!data.isSomenteLeitura) {
      @if (mostraAbasFiscais) {
        <button mat-stroked-button type="button" class="btn-secondary" (click)="recalcularTributos()">
          <mat-icon class="material-symbols-outlined">calculate</mat-icon>
          Recalcular tributos
        </button>
      }
      <button mat-flat-button type="button" class="btn-primary" (click)="salvar()">
        <mat-icon class="material-symbols-outlined">check</mat-icon>
        Confirmar
      </button>
    }
  </div>
</mat-dialog-actions>
